<template>
	<el-container>
		<el-header class="nav-container" style="height: auto !important;">
			<navbar 
				:nav-index="5" 
				@nav-items-click="navClick" 
				@pop-click="popClick" />
		</el-header>
		<div class="items" id="crm-main-container">
			<app-main />
		</div>
		<edit-password 
			:show="showEditPassword" 
			@close="showEditPassword=false" />
	</el-container>
</template>

<script>
	import { mapGetters } from 'vuex'
	import {
		Navbar,
		AppMain
	} from './components'
	import EditPassword from './components/EditPassword'
	

	export default {
		name: 'Layout',
		components: {
			Navbar,
			AppMain,
			EditPassword
		},

		data() {
			return {
				isCreate: false,
				createCRMType: '',
				showEditPassword: false
			}
		},
		computed: {
			...mapGetters(['allAuth']),

		},
		created() {
			
		},

		mounted() {
			
		},

		methods: {
			navClick() {},
			popClick() {
				this.showEditPassword = true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.el-container {
		min-height: 100%;
	}

	

	.nav-container {
		padding: 0;
		// box-shadow: 0px 1px 2px #dbdbdb;
		z-index: 100;
		min-width: 1200px;
	}
	.items{
		display: flex;
		// background-color: #f2f2f2; 
		align-items: center; 
		flex-direction: column; 
		min-height: 100vh;
	}
	
</style>
